import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { getCalendarByUserID, getUserCalendar } from "services/calendar.service";
import { addEvent, checkAvailable, deleteEvent, getEvent, getUserEvents, updateEvent } from "services/event.service";
import { getWorkingHour, updateWorkingHour } from "services/workingHour.service";

export const getEvents = createAsyncThunk("calendar/getEvents", async () => {
    try {
        const response = getEvent();
        return response;
    } catch (error) {
        return error;
    }
});
export const addEvents = createAsyncThunk("calendar/addEvents", async (event: any) => {
    try {
        const response = addEvent(event);
        const data = await response;
        toast.success("Event Added Successfully", { autoClose: 2000 });
        return data;
    } catch (error) {
        toast.error("Event Added Failed", { autoClose: 2000 });
        return error;
    }
});
export const updateEvents = createAsyncThunk("calendar/updateEvents", async ({ id, event }: { id: string; event: any }) => {
    try {
        const response = updateEvent(id, event);
        const data = await response;
        toast.success("Event updated Successfully", { autoClose: 2000 });
        return data;
    } catch (error) {
        toast.error("Event updated Failed", { autoClose: 2000 });
        return error;
    }
});
export const deleteEvents = createAsyncThunk("calendar/deleteEvents", async (id: string) => {
    try {
        const response = deleteEvent(id);
        toast.success("Event deleted Successfully", { autoClose: 2000 });
        return response;
    } catch (error) {
        toast.error("Event deleted Failed", { autoClose: 2000 });
        return error;
    }
});

export const getCalendar = createAsyncThunk("calendar/geCalendar", async () => {
    try {
        const response = getUserCalendar();
        return response;
    } catch (error) {
        return error;
    }
});

export const getUserEvent = createAsyncThunk("calendar/getUserEvent", async () => {
    try {
        const response = getUserEvents();
        return response;
    } catch (error) {
        return error;
    }
});


export const checkUserAvailable = createAsyncThunk("calendar/checkAvailable", async ({ from, to, timeZone, timeRange }: { from: string; to: string; timeZone: string; timeRange: string }) => {
    try {
        const response = checkAvailable({ from, to, timeZone, timeRange });
        return response;
    } catch (error) {
        return error;
    }
});

export const getCalendarByUser = createAsyncThunk("calendar/getCalendarByUser", async (id: string) => {
    try {
        const response = getCalendarByUserID(id);
        return response;
    } catch (error) {
        return error;
    }
});

export const getWorkingHourUSer = createAsyncThunk("calendar/getWorkingHour", async () => {
    try {
        const response = getWorkingHour();
        return response;
    } catch (error) {
        return error;
    }
});

export const updateWorkingHourUSer = createAsyncThunk("calendar/updateWorkingHour", async (payload: any) => {
    try {
        const response = await updateWorkingHour(payload).then((res: any) => {
            if (res) {
                toast.success("Working hour and break time settings updated successfully", { autoClose: 2000 });
            } else {
                toast.error("Working Hour updated Failed", { autoClose: 2000 });
            }
        }).catch((err: any) => {
            toast.error("Working Hour update encountered an error", { autoClose: 2000 });
        });
        return response;
    } catch (error) {
        return error;
    }
});
